import { useQuery, useMutation } from '@tanstack/react-query'
import {
  startDatabaseTransfer,
  getDatabaseTransferStatus,
  listServers,
  TransferDatabaseRequest,
  TransferStatusResponse,
  AdminServerModel,
} from './databaseTransfer'

/** Terminal states — polling stops once the job reaches one of these. */
const TERMINAL_TRANSFER_STATUSES = new Set(['completed', 'failed', 'unknown'])

export function isTransferInProgress(status: string | null | undefined): boolean {
  return status != null && !TERMINAL_TRANSFER_STATUSES.has(status)
}

export function useQueryServers() {
  return useQuery<AdminServerModel[]>({
    queryKey: ['config.servers'],
    queryFn: async () => {
      const { data } = await listServers()
      const arr = Array.isArray(data) ? data : []
      return arr.map((s: any) => ({
        id: Number(s.id),
        name: s.name,
        address: s.address,
        isPrivate: s.isPrivate,
      }))
    },
    staleTime: 60_000,
  })
}

export function useMutationStartTransfer() {
  return useMutation({
    mutationFn: (request: TransferDatabaseRequest) =>
      startDatabaseTransfer(request).then((r) => r.data),
  })
}

export function useTransferStatus(jobId: string | null) {
  return useQuery<TransferStatusResponse>({
    queryKey: ['database-transfer-status', jobId],
    queryFn: async () => {
      const { data } = await getDatabaseTransferStatus(jobId!)
      return data
    },
    enabled: jobId != null,
    refetchInterval: (data) =>
      data && TERMINAL_TRANSFER_STATUSES.has((data as any).status) ? false : 2000,
  })
}
